// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"5471":"feefc61b","7902":"8ff78529"}[chunkId] || chunkId) + "." + {"1454":"e710f144cec10a29","5471":"21a62076b6a83e21","7902":"b54bb2f362c30686"}[chunkId] + ".js";
};